import axios from 'axios';
import { ApiLoginParams, ApiLoginStatus, ApiLoginUser, ApiUserAccountById, IApiManufactory, IApiUserSession } from './account-service.types';
import { getServerError } from '../error/error-service';

const AuthApiBaseUrl = `/auth/api`;

export const getSession = (token: string | null, app?: string): Promise<IApiUserSession> => {
    return axios.get<IApiUserSession>(`${AuthApiBaseUrl}/session`, { params: { token, app } })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const signOut = () =>
    axios.post<IApiUserSession>(`${AuthApiBaseUrl}/logout`)
        .catch((error) => {
            throw getServerError(error);
        });

export const getLoginStatus = () => {
    return axios.get<ApiLoginStatus>(`${AuthApiBaseUrl}/login/stat`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const singIn = (params: ApiLoginParams) => {
    return axios.post<ApiLoginUser>(`${AuthApiBaseUrl}/login`, params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const getDepartmentListByRole = (role: string) =>
    axios.get<{ departments: IApiManufactory[] }>(`${AuthApiBaseUrl}/login/department`, { params: { role } })
        .then((res) => res.data.departments)
        .catch((error) => {
            throw getServerError(error);
        });


// app.route('/api/user/by-ids').get(
export const getUserAccountById = (id: number[]) =>
    axios.get<{ users: ApiUserAccountById[] }>(`${AuthApiBaseUrl}/user/by-ids`, { params: { ids: id } })
        .then((res) => res.data.users)
        .catch((error) => {
            throw getServerError(error);
        });
